// src/config/api.js
// Default API Base URL
const rawUrl = process.env.REACT_APP_API_BASE || 'https://dev.revexia.ai/api';

// Remove any trailing slash to ensure clean endpoint formatting
export const API_BASE = rawUrl.replace(/\/+$/, '');

/**
 * Utility function to get full API endpoint URL safely without duplicate /api/api
 * @param {string} path - API endpoint path (e.g., '/auth/login' or 'blog/')
 * @returns {string} full endpoint URL
 */
export const getApiUrl = (path = '') => {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  if (API_BASE.endsWith('/api') && cleanPath.startsWith('/api/')) {
    return `${API_BASE}${cleanPath.substring(4)}`;
  }
  return `${API_BASE}${cleanPath}`;
};

export default API_BASE;
